export default __webpack_public_path__ + "static/media/firstcolony.c063729c.png";